import { provideWidgetClass } from "scrivito"

export const ButtonGroupWidget = provideWidgetClass("ButtonGroupWidget", {
  attributes: {
    buttons: ["widgetlist", { only: ["ButtonWidget", "LoginButtonWidget"] }]
  }
})
